import axios from 'axios';

const DefaultApi = ({
    params,
    method,
    url
}) => {
    switch (method) {
        case 'get': return axios.get(url, {params});
        case 'post': return axios.post(url, params);
        case 'put': return axios.put(url, params);
        default: return null
    }
};

export {
    DefaultApi
}